import React from 'react';
import { Helmet } from 'react-helmet';
import { filter, unionBy } from 'lodash';

function mergeTags(a, b, prop) {
  return unionBy(filter(b, prop), filter(a, prop), prop);
}

export default function YoastMeta({ meta }) {
  const { yoast_meta: yoastMeta, yoast_title: yoastTitle, overrides } = meta;
  const nameTags = mergeTags(yoastMeta, overrides, 'name');
  const propertyTags = mergeTags(yoastMeta, overrides, 'property');
  return (
    <Helmet title={yoastTitle} defer={false}>
      {nameTags.map((tag, i) =>
        <meta key={`tag-${i}`} name={tag.name} content={tag.content} />
      )}
      {propertyTags.map((tag, i) =>
        <meta key={`tag-${i}`} property={tag.property} content={tag.content} />
      )}
    </Helmet>
  );
}